module.exports = __webpack_public_path__ + "img/3.e478a123.svg";